import { useCallback, useMemo, useState } from "react";

export function useFirstInteraction() {
  const [firstInteractionSet, setFirstInteractionSet] = useState<Set<string>>(
    new Set()
  );
  const add = useCallback((id: string) => {
    return setFirstInteractionSet((p) => {
      const n = new Set(p);
      n.add(id);
      return n;
    });
  }, []);

  const remove = useCallback((id: string) => {
    return setFirstInteractionSet((p) => {
      const n = new Set(p);
      n.delete(id);
      return n;
    });
  }, []);

  const r = useMemo(() => {
    return {
      value: firstInteractionSet,
      has: firstInteractionSet.has.bind(firstInteractionSet),
      add,
      remove,
    };
  }, [add, remove, firstInteractionSet]);

  return r;
}
